import axios from "axios";
import { InfluencerProfileT } from "../types";

export const getInfluencerProfile = async (
  apiUrl: string
): Promise<InfluencerProfileT> => axios.get(apiUrl).then((res) => res.data);
